import { identity } from 'lodash';
import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import cn from 'classnames';
import { ReactHeight } from 'react-height';
import VirtualScroll from 'virtual-scroll-component';
import styles from './pagination_container.scss';

const LoadMoreButton = ({ handleLoadMore, settings, canLoadMore }) => (
  <div className={cn(styles.loadMoreContainer, { [styles.noMoreLoad]: !canLoadMore })}>
    <Button onClick={handleLoadMore} className="pagination-load-more">
      {settings.get('loadMoreButtonText')}
    </Button>
  </div>
);

function PaginationContainer({ events, transform, settings, onResizeComponent, renderEvent }) {
  const eventPageSize = settings.get('eventPageSize', 5);
  const enablePagination = settings.get('enablePagination');
  const [displayCount, setDisplayCount] = useState(enablePagination ? eventPageSize : events.size);
  const [height, setHeight] = useState(null);

  const loadMoreEvents = () => {
    if (enablePagination) {
      setDisplayCount(displayCount + eventPageSize);
    }
  };
  useEffect(() => {
    if (displayCount > 0) {
      onResizeComponent();
    }
  }, [displayCount]);
  useEffect(() => {
    const newEnablePagination = settings.get('enablePagination');
    const newEventPageSize = settings.get('eventPageSize', 5);
    setDisplayCount(newEnablePagination ? newEventPageSize : events.size);
  }, [settings.get('enablePagination'), settings.get('eventPageSize')]);

  const slicedEvents = events.slice(0, displayCount);
  const transformedEvents = transform ? transform(slicedEvents) : slicedEvents;
  const rows = transformedEvents
    .map((event, index) => <ReactHeight onHeightReady={(h) => setHeight(Math.max(h, height))}>{renderEvent(event, index)}</ReactHeight>)
    .toJS();

  return (
    <div>
      {events.length > 15 ? <VirtualScroll rows={rows} onLastRow={identity} rowHeight={height} /> : <>{rows}</>}
      {enablePagination && <LoadMoreButton settings={settings} handleLoadMore={loadMoreEvents} canLoadMore={displayCount < events.size} />}
    </div>
  );
}

export default PaginationContainer;
